import DOMPurify from "dompurify";

/**
 * Sanitizes HTML to prevent XSS attacks.
 * During SSR, returns HTML as-is (DOMPurify requires DOM).
 * Content is sanitized on client hydration before any scripts could execute.
 */
export function sanitizeHtml(html: string): string {
	if (typeof window === "undefined") {
		return html;
	}
	return DOMPurify.sanitize(html, {
		FORBID_TAGS: ["script", "style", "iframe", "object", "embed", "form"],
		FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover"],
	});
}
